import React, { Component } from "react";
import "../../css/salesstats.css";
import { Button, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { ReportService } from "../../Services/ReportService";
import { format_date_only } from "../../Utils";
import { Paper } from "@material-ui/core";

export default class SalesReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        startDate: moment().startOf('month'),
        endDate: moment(),
        message : "",
        rows: []
      }
      this.handleChangeStart = this.handleChangeStart.bind(this);
      this.handleChangeEnd = this.handleChangeEnd.bind(this);
    }
    
 
    componentDidMount(){
        this.props.setTitle('Sales Report');
        this.fetchData();
    }

    fetchData(){
        this.props.isLoading(true);
        ReportService.getReportSalesReport(this.state.startDate, this.state.endDate)
        .then((data) => {
            console.log(data);
            let dataIn = [];
            data.report.forEach(report => {
                dataIn.push(<ReportDetails key={report.product} report={report}/>);
            });
            this.setState({rows: dataIn})
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChangeStart(date){
        this.setState({
            startDate: date
        });
    }

    handleChangeEnd(date){
        this.setState({
            endDate: date
        });
    }
    
    render() {
        const message = this.state.message;
        return (
            <div className="Home sales-stats" style={{marginTop: 32}}>
                <Paper style={{paddingTop: 8 ,paddingBottom: 8}}>
                    <div className="rangeContainer">
                    <div className="centerwrapper">
                        <div className = "squareLabel marginRight">From</div>
                        <div className = "square">
                            <DatePicker
                                selected={this.state.startDate}
                                selectsStart
                                dateFormat={format_date_only}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                onChange={this.handleChangeStart} />
                        </div>
                        <div className = "squareLabel">To</div>
                        <div className = "square">
                            <DatePicker
                                selected={this.state.endDate}
                                selectsEnd
                                dateFormat={format_date_only}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                onChange={this.handleChangeEnd}
                            />
                        </div>
                        <div className = "square_buttons">
                            <Button onClick={(e) => { this.fetchData(e)}}>REFRESH</Button>
                        </div>
                    </div>
                    </div>
                    { !this.props.loading &&
                        <div className="container">
                            <Table striped condensed hover responsive>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Actual Count</th>
                                        <th>Delivered Count</th>
                                        <th>Returned Count</th>
                                        {/* <th>Bottles Returned Count</th> */}
                                    </tr>
                                </thead>
                                <tbody style={{textAlign: "left"}}>
                                    {this.state.rows}
                                </tbody>
                            </Table>
                        </div>
                    }
                    {
                        message && 
                        (
                            <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                        )
                    }
                </Paper>
            </div>
        );
    }

}

class ReportDetails extends Component {

    render(){
        const report = this.props.report;
        // const isBottled = report.bottled === "1" ? true : false;
        return (
            <tr>
                <td>{report.product}</td>
                <td>{report.actual_count}</td>
                <td>{report.delivered_count}</td>
                <td>{report.returned_count}</td>
                {/* <td>{isBottled ? report.bottles_returned : "NA"}</td> */}
            </tr>
        );
    }
}